import React, { FC, useMemo } from "react";

import { CreditNoteReasons, PaymentStatuses } from "@api/graphql";
import { getDisplayValueFromDBValue } from "@util/index";
import { mapStatusToDisplayFriendlyText } from "@util/resale";

import { StatusBadge } from "./StatusBadge";

import styles from "./PaymentStatusBadge.module.scss";

interface PaymentStatusBadgeProps {
  cellValue: PaymentStatuses | undefined;
  isExternalUser?: boolean;
  creditNoteReason?: CreditNoteReasons;
}

export const PaymentStatusBadge: FC<PaymentStatusBadgeProps> = ({ cellValue, isExternalUser, creditNoteReason }) => {
  const currentPaymentStatus = useMemo(() => {
    return mapStatusToDisplayFriendlyText({ status: cellValue, isExternalUser: isExternalUser || false });
  }, [cellValue, isExternalUser]);

  const cellValueToDisplay = useMemo(() => {
    if (creditNoteReason) {
      const reason = creditNoteReason && getDisplayValueFromDBValue(creditNoteReason, isExternalUser);
      return `${currentPaymentStatus?.label}: ${reason}`;
    }
    return currentPaymentStatus?.label;
  }, [creditNoteReason, currentPaymentStatus?.label, isExternalUser]);

  if (!cellValue) {
    return <StatusBadge cellClassName="pending-payment-undefined-badge" cellValue="undefined" customStyle={styles} />;
  }

  return (
    <StatusBadge cellClassName={currentPaymentStatus?.className} cellValue={cellValueToDisplay} customStyle={styles} />
  );
};
// check how diffcult to merge filter
